import { useState } from 'react';

import {
  MobileDatepicker,
  MultipleSelectFilter,
  SideModal,
  SingleSelectFilter,
  TimeRangeFilter,
} from '../../components';
import { intervalsDate } from '../../constants/analytics.constants';
import { useChartInterval } from '../../hooks/useChartInterval';

export const DashboardFiltersModal = ({
  login,
  info,
  potato = false,
  potatoChutesOptions,
  packageTypesOptions,
  chickenTypesOptions,
  onConfirm,
  onCancel,
  isTimeRangeEnabled,
}) => {
  const [restaurantUuid] = useState(info.restaurantUuid);

  const [potatoChutes, setPotatoChutes] = useState(info.potatoChutes);
  const [packageTypes, setPackageTypes] = useState(info.packageTypes);
  const [chickenTypes, setChickenTypes] = useState(info.chickenTypes);
  const [timeRange, setTimeRange] = useState({ start: info.startTimeInterval, end: info.endTimeInterval });
  const [dates, setDates] = useState({
    startDate: info.startDate,
    endDate: info.endDate,
    timeInterval: info.timeInterval,
  });
  const [interval, setInterval] = useState(info.interval);

  const isEnable =
    dates.startDate !== info.startDate ||
    dates.endDate !== info.endDate ||
    dates.timeInterval !== info.timeInterval;
  const intervalState = useChartInterval(dates.startDate, dates.endDate, dates.timeInterval, (value) => {
    if (isEnable) {
      setInterval(value);
    }
  });

  return (
    <SideModal
      withoutPadding={true}
      size={'sm'}
      title="Filters"
      onCancel={() => {
        onCancel();
      }}
      onConfirm={() => {
        onConfirm({
          restaurantUuid,
          ...(potato ? { potatoChutes, packageTypes } : { chickenTypes }),
          startDate: dates.startDate,
          endDate: dates.endDate,
          timeInterval: dates.timeInterval,
          interval,
          timeIntervalIcon: intervalsDate.find((item) => item.value === dates.timeInterval)?.icon,
          ...(isTimeRangeEnabled && {
            startTimeInterval: timeRange.start,
            endTimeInterval: timeRange.end,
          }),
        });
      }}
      modalBody={
        <div className="mobile-filters__modal dashboard-mobile-filters">
          <SingleSelectFilter
            title="Interval"
            name="interval"
            options={intervalState}
            value={interval}
            onChange={(_name, value) => {
              setInterval(value);
            }}
          />
          {potato ? (
            <>
              <MultipleSelectFilter
                title="Products"
                name="packageTypes"
                rightAlign={restaurantUuid !== null && restaurantUuid !== 'select'}
                options={packageTypesOptions}
                values={packageTypes}
                onChange={(data) => {
                  setPackageTypes(data);
                }}
              />
              <MultipleSelectFilter
                title="Section"
                name="potatoChutes"
                rightAlign={restaurantUuid === null || restaurantUuid === 'select'}
                options={potatoChutesOptions}
                values={potatoChutes}
                onChange={(data) => {
                  setPotatoChutes(data);
                }}
              />
            </>
          ) : (
            <MultipleSelectFilter
              title="Products"
              name="chickenTypes"
              rightAlign={restaurantUuid !== null && restaurantUuid !== 'select'}
              options={chickenTypesOptions}
              values={chickenTypes}
              onChange={(data) => {
                setChickenTypes(data);
              }}
            />
          )}
          {isTimeRangeEnabled && (
            <TimeRangeFilter
              range={{ start: timeRange.start, end: timeRange.end }}
              handleChange={(value) => {
                setTimeRange(value);
              }}
              clearable
            />
          )}
          <MobileDatepicker
            start={dates.startDate}
            end={dates.endDate}
            timeInterval={dates.timeInterval}
            timezone={login.restaurantOptions.find((option) => option.value === restaurantUuid)?.timezone}
            defaultValue={intervalsDate.find((item) => item.icon === '1mo').value}
            onChange={({ startDate, endDate }) => {
              setDates((prev) => ({ ...prev, startDate, endDate }));
            }}
          />
        </div>
      }
      confirmText="Save"
    />
  );
};
